import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { setDatasourceId, setDocumentId } from '@/redux/session/actions';
import { selectOpenSidebar } from '@/redux/sidebar/selectors';
import { SidebarOptions } from '@/shared/types/sidebar';

// Panels that read the selected row's datasource/document id from session. The add_* panels are
// here because they double as edit panels; their create paths call resetReduxState() themselves.
const SELECTION_PANELS: SidebarOptions[] = [
  'edit_document',
  'add_txt_document',
  'add_faq',
  'upload_documents',
  'upload_faq',
  'rename_folder',
  'ingestion_report',
  'add_webpages',
  'add_external_sources',
];

/**
 * Clears the datasource/document selection whenever the open panel doesn't own a row selection,
 * and whenever the collection changes. A selection is only ever made from a row menu on a mounted
 * page, so one present on mount or after a collection change belongs to another page.
 */
export const useResetSidebarSelection = () => {
  const dispatch = useDispatch();
  const content = useSelector(selectOpenSidebar);
  const { collectionId } = useParams();

  useEffect(() => {
    if (content && SELECTION_PANELS.includes(content)) {
      return;
    }
    dispatch(setDatasourceId(null));
    dispatch(setDocumentId(null));
  }, [content, dispatch]);

  useEffect(() => {
    dispatch(setDatasourceId(null));
    dispatch(setDocumentId(null));
  }, [collectionId, dispatch]);
};
